export default __webpack_public_path__ + "static/media/L2.195222f5.svg";